import { ESessionKeys } from "../../@types";
const storage = window.localStorage;
const setToken = (key, val) => {
    storage.setItem(key, val);
};
export const setAccessToken = (val) => {
    setToken(ESessionKeys.AccessToken, val);
};
export const setRefreshToken = (val) => {
    setToken(ESessionKeys.RefreshToken, val);
};
export const setMember = (val) => {
    setToken(ESessionKeys.Member, val);
};
const getToken = (key) => storage.getItem(key);
export const getRefreshToken = () => getToken(ESessionKeys.RefreshToken);
export const getAccessToken = () => getToken(ESessionKeys.AccessToken);
export const getMember = () => getToken(ESessionKeys.Member);
export const clearAccessToken = () => storage.removeItem(ESessionKeys.AccessToken);
export const clearSession = () => {
    clearAccessToken();
    storage.removeItem(ESessionKeys.RefreshToken);
    storage.removeItem(ESessionKeys.Member);
};
